import { render, staticRenderFns } from "./Alf.vue?vue&type=template&id=5380ca98"
import script from "./Alf.vue?vue&type=script&lang=js"
export * from "./Alf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports